import React, { useCallback } from 'react';
import { styled, css } from '@compiled/react';
import ArrowRightIcon from '@atlaskit/icon/core/arrow-right';

import { token } from '@atlaskit/tokens';
import { fg } from '@atlassian/jira-feature-gating';
import { useTransformNavigationCommands } from '@atlassian/jira-command-palette-common/src/common/utils/transform-navigation-commands/index.tsx';
import type { Command } from '@atlassian/jira-command-palette/src/common/types/commands/index.tsx';
import type { ViewAllCommandProps } from './types.tsx';

export const useGetViewAllCommand = () => {
	const { transformNavigationCommand } = useTransformNavigationCommands();

	const getViewAllCommand = useCallback(
		({
			name,
			url,
			isRecommended = false,
			analyticsPayload = {},
			...rest
		}: ViewAllCommandProps): Command =>
			transformNavigationCommand(
				{
					name,
					components: {
						Name: () => (
							<RenderNameWrapper
								data-testid="command-palette-quick-search.common.ui.view-all.render-name-wrapper"
								isRecommended={isRecommended}
							>
								{name}
							</RenderNameWrapper>
						),
						LeftIcon: () => (
							<ArrowRightIcon
								color="currentColor"
								size="small"
								label=""
								aria-hidden={fg('deliveroo_compal_a11y_fixes') ? true : undefined}
							/>
						),
					},
					analytics: {
						action: 'quickSearchViewAll',
						...analyticsPayload,
					},
					...rest,
				},
				{ path: url },
			),
		[transformNavigationCommand],
	);

	return { getViewAllCommand };
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const RenderNameWrapper = styled.div<{ isRecommended: boolean }>(
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	({ isRecommended }) =>
		!isRecommended &&
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
		css({
			color: token('color.text.brand'),
		}),
);
